function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Add to my Transfer Planner");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Profile---Hubs---Transfer",
  transform: "translate(-1233.000000, -2595.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11",
  transform: "translate(0.000000, 2041.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stacked-Group-3-Copy-3",
  transform: "translate(206.000000, 114.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stacked-Group-6",
  transform: "translate(0.000000, 373.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stacked-Group-2-Copy-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stacked-Group-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rectangle-2",
  transform: "translate(0.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stacked-Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(875.000000, 27.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Avatar/Icon",
  transform: "translate(152.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Container/Circular"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,0 C31.045695,-2.02906125e-15 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 1.3527075e-15,31.045695 0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 Z",
  id: "Color",
  fill: "#35C4BB"
}), /*#__PURE__*/React.createElement("g", {
  id: "State"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,0 C31.045695,-2.02906125e-15 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 1.3527075e-15,31.045695 0,20 C-1.3527075e-15,8.954305 8.954305,2.02906125e-15 20,0 Z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(12.000000, 12.000000)",
  fill: "#363648"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,7 L9,7 L9,1 C9,0.4 8.6,0 8,0 C7.4,0 7,0.4 7,1 L7,7 L1,7 C0.4,7 0,7.4 0,8 C0,8.6 0.4,9 1,9 L7,9 L7,15 C7,15.6 7.4,16 8,16 C8.6,16 9,15.6 9,15 L9,9 L15,9 C15.6,9 16,8.6 16,8 C16,7.4 15.6,7 15,7 Z",
  id: "Fill"
}))))))))))))));

var SvgAddToTransferPlanner = function SvgAddToTransferPlanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddToTransferPlanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-to-transfer-planner.eae80b35.svg";
export { ForwardRef as ReactComponent };